import type { FieldDef } from '../types';

// Assigns `sectionKey` to the selected fields and moves them into a contiguous
// block at the position of the earliest selected field, preserving their
// relative order. Sections are contiguous runs in the schema, so grouping a
// scattered selection has to pull the fields together.
const groupIntoSection = (
  fields: FieldDef[],
  selectedKeys: Set<string>,
  sectionKey: string
): FieldDef[] => {
  const firstIndex = fields.findIndex((field) => selectedKeys.has(field.key));
  if (firstIndex === -1) return fields;

  const selected = fields
    .filter((field) => selectedKeys.has(field.key))
    .map((field) => ({ ...field, sectionKey }));
  const rest = fields.filter((field) => !selectedKeys.has(field.key));
  // Insert the block where the first selected field used to sit, measured among
  // the fields that remain.
  const insertAt = fields
    .slice(0, firstIndex)
    .filter((field) => !selectedKeys.has(field.key)).length;

  return [...rest.slice(0, insertAt), ...selected, ...rest.slice(insertAt)];
};

export default groupIntoSection;
